import { setOptions } from '@googlemaps/js-api-loader';

// `@googlemaps/js-api-loader` warns when `setOptions` is called more than once, but
// multiple unrelated features (LocationSearchBox, LocationSearchLayout, LocationMap)
// all need to ensure the loader is configured before importing libraries. This module
// owns the single setOptions call; callers invoke it ahead of any importLibrary use
// and only the first call takes effect.
let configured = false;

export function configureGoogleMapsLoader(apiKey: string): void {
  if (configured) return;
  if (!apiKey) return;
  setOptions({ key: apiKey });
  configured = true;
}
